import React from 'react';
import Button from './button';

export default function Success(props) {
  return <Button variant="success" {...props} />;
}
